module.exports = __webpack_public_path__ + "img/avatar.a04d849c.jpg";